<template>
  <div class="kp-datetime d-flex align-center ga-4">
    <span class="text-headline-large text-white">{{ friendlyTime }}</span>
    <div class="kp-datetime__date d-flex flex-column text-body-small text-color_g">
      <span class="text-capitalize text-no-wrap">{{ friendlyDayName }}</span>
      <span class="text-no-wrap">{{ friendlyDate }}</span>
    </div>
  </div>
</template>

<script setup>
import {
  computed, ref, onBeforeUnmount, onMounted,
} from 'vue';
import useDayjs from '~/composables/useDayjs';

const { $dayjs, localFormatTime } = useDayjs();

// Stores the interval id for the time update
const pidTime = ref(null);
// Stores the raw time
const rawTime = ref(+new Date());
// Friendly date and time
const friendlyDayName = computed(() => $dayjs(rawTime.value).format('dddd'));
const friendlyDate = computed(() => $dayjs(rawTime.value).format('LL'));
const friendlyTime = computed(() => localFormatTime($dayjs(rawTime.value), false));

const setTime = () => {
  rawTime.value = +new Date();
  clearInterval(pidTime.value);
  pidTime.value = setInterval(() => {
    setTime();
  }, 1000);
};

onMounted(() => {
  setTime();
});
onBeforeUnmount(() => {
  if (pidTime.value) clearInterval(pidTime.value);
});
</script>

<style scoped lang="scss">
.kp-datetime__date {
  line-height: 1.2;
}
</style>
